import React, { useState } from "react";
import { DateRangePicker } from "rsuite";
import CalendarIcon from "@rsuite/icons/Calendar";  
// import "rsuite/dist/rsuite.min.css";
import { useTranslation } from "react-i18next";

import Calendar from '../assets/Calendar.png'

const TravelDatePicker = () => {
  
  const { t, i18n } = useTranslation();

  const [value, setValue] = useState([new Date(), new Date()]);

  // Determine locale based on current language
  const locale = i18n.language === "ar" ? "ar-EG" : "en-US";

  return (
    <div className="calendar-box input-hide-btn btn-border-box d-flex align-items-center gap-1 position-relative">
      {/* Hidden Input for form */}
      <input
        type="hidden"
        name="daterange"
        value={`${value[0]?.toLocaleDateString()} - ${value[1]?.toLocaleDateString()}`}
      />

      {/* Left Icon (using @rsuite/icons instead of broken PNG) */}
      <div className="left-icons">
        <img src={Calendar} alt="" />
      </div>

      {/* Right Calendar Details */}
      <div className="right-calendar-details">
        <p>{t("Travel Date")}</p>
        <h5>
          {value[0]
            ? value[0].toLocaleDateString(locale, {
                weekday: "short",
                day: "numeric",
                month: "short",
              })
            : t("Select Date")}
        </h5>
      </div>

      {/* RSuite Picker (invisible overlay) */}
      <DateRangePicker
        value={value}
        onChange={setValue}
        appearance="subtle"
        className="position-absolute w-100 h-100 top-0 start-0 opacity-0"
        placement="bottomStart"
        format="dd/MM/yyyy"
      />
    </div>
  );
};

export default TravelDatePicker;


